import { jsx as l } from "react/jsx-runtime";
const a = ({
  productSectionBadge: r,
  variant: o
}) => {
  if (!(!r || !r.text))
    return /* @__PURE__ */ l(
      "div",
      {
        className: `product-card-section-badge-container ${o === "horizontal" && "horizontal"}`,
        style: r && {
          color: r.color.textColor,
          backgroundColor: r.color.backGroundColor
        },
        children: /* @__PURE__ */ l("p", { className: "product-card-section-badge-text", children: r == null ? void 0 : r.text })
      }
    );
};
export {
  a as ProductCardPromotionFlag
};
